import { AxiosInstance } from 'axios'
import LetsDialAPI, { LetsDialAPIType } from '@letsdial/api/src'
import { useAuthStore } from '/@/store/authStore'

export let letsDialAPI: LetsDialAPIType | undefined

export default {
  install: (app: any, axios: AxiosInstance, baseUrl = '/api') => {
    axios.interceptors.response.use(
      (resp) => resp,
      (err) => {
        console.log(err.response)
        if (
          err.response &&
          err.response.status === 401 &&
          err.response.config.url !== '/users/sessions' &&
          err.response.config.method !== 'delete'
        ) {
          console.log(err)
          const auth = useAuthStore()
          auth.logout()
        }
        return Promise.reject(err)
      },
    )
    letsDialAPI = LetsDialAPI(axios, baseUrl)
    app.config.globalProperties.$letsDialAPI = letsDialAPI
    app.$letsDialAPI = app.config.globalProperties.$letsDialAPI
  },
}
